import type { RefineImageResponse } from '@pulsify/shared/dto'
import { adminBypassHeaders } from '~/app/admin-bypass'
import { api, getAuthToken, unwrap } from '~/shared/lib/rpc'

export const refineApi = {
  async refine(businessId: string, file: File, prompt: string): Promise<RefineImageResponse> {
    const url = api.api.businesses[':businessId']['ai-studio'].refine.$url({
      param: { businessId },
    })
    const formData = new FormData()
    formData.append('file', file)
    formData.append('prompt', prompt)
    const token = await getAuthToken()
    const headers: Record<string, string> = { ...adminBypassHeaders() }
    if (token) headers.Authorization = `Bearer ${token}`
    const res = await fetch(url, { method: 'POST', body: formData, headers })
    return unwrap<RefineImageResponse>(res)
  },
}
